import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import "./Stripe.css";
import { BiLinkExternal } from "react-icons/bi";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../../../components/CommonComponents/MessageSubHeading";
import { Link } from "react-router-dom";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import { toast } from "react-toastify";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import DeviceSelector from "../../../../components/PaymentComponents/DeviceSelector";

function GooglePay() {
  const { fetchRequest } = useMyContext()
  const [formData, setFormData] = useState({})
  const [formDataError, setFormDataError] = useState({})
  const [loading, setLoading] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);

  // Supported devices from backend helper
  const [supportedDevices, setSupportedDevices] = useState(['web', 'Android', 'iOS', 'TV']);

  const combinedRef = useRef({});

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === 'text' || type === 'textarea') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleDeviceChange = (updatedDevices) => {
    // Filter only valid devices and ensure it's an array
    const validDevices = Array.isArray(updatedDevices)
      ? updatedDevices.filter(device => supportedDevices.includes(device))
      : [];

    console.log('GooglePay Device change:', { updatedDevices, validDevices, supportedDevices });

    setFormData((prev) => ({
      ...prev,
      supported_devices: validDevices
    }));
  };

  const formValidation = () => {
    let formIsValid = true;

    // Validate supported devices
    if (!formData?.supported_devices || !Array.isArray(formData.supported_devices) || formData.supported_devices.length === 0) {
      toast.warning('Please select at least one supported device.');
      formIsValid = false;
    }

    if (!formData?.unified_product_id) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        unified_product_id: "Product ID cannot be empty.",
      }));
      combinedRef.current['unified_product_id'].focus()
      formIsValid = false;
    }

    return formIsValid;
  }

  const handleStore = async () => {
    console.log('GooglePay Form data before validation:', formData);
    if (formValidation()) {
      setLoading(true)
      const dataToSend = {
        ...formData,
        supported_devices: JSON.stringify(formData.supported_devices || [])
      };
      console.log('GooglePay Data being sent:', dataToSend);

      await fetchRequest({
        method: 'POST',
        url: `${process.env.REACT_APP_Baseurl}/admin/googlepay_payment/store`,
        params: {},
        data: dataToSend,
      })
        .then(response => {
          if (response?.status) {
            toast.success(response?.message)
            setWithOutRefresh((prev) => !prev)
          }
        }).catch((error => {
          toast.error(error?.response?.data?.message)
        })).finally(() => {
          setLoading(false)
        })
    }
  }

  useEffect(async () => {
    setShowOverlay(true)

    // Fetch supported devices from backend
    try {
      const deviceResponse = await fetchRequest({
        method: 'GET',
        url: `${process.env.REACT_APP_Baseurl}/admin/supported-devices`,
        params: {},
        data: {},
      });

      if (deviceResponse?.status && deviceResponse?.data) {
        setSupportedDevices(deviceResponse.data);
      }
    } catch (error) {
      console.warn('Using default supported devices:', error);
    }

    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/googlepay_payment/index`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          const googlepayData = response?.googlepay_payment;
          let deviceArray = []; // default

          // Parse supported_devices if it exists
          if (googlepayData?.supported_devices) {
            try {
              const parsedDevices = typeof googlepayData.supported_devices === 'string'
                ? JSON.parse(googlepayData.supported_devices)
                : googlepayData.supported_devices;
              deviceArray = Array.isArray(parsedDevices) ? parsedDevices : [];
              console.log('GooglePay Loaded devices:', deviceArray);
            } catch (error) {
              console.warn('Invalid supported_devices format:', googlepayData.supported_devices);
              deviceArray = [];
            }
          }

          setFormData((prev) => ({
            ...prev,
            ...googlepayData,
            supported_devices: deviceArray
          }));
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message)
      })).finally(() => {
        setShowOverlay(false)
      })
  }, [withOutRefresh]);

  return (
    <>

      {showOverlay && (<Response_Processing />)}
      <AdminBackNavigation id="playout-backbtn" path="/payment_settings" text="Back" />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Google Pay Configuration" />
            <Link to="https://developers.google.com/pay" target="_blank" className="d-inline-flex  align-items-center gap-2 p-2 rounded-2 shadow mb-4">
              <MessageSubHeading text="https://developers.google.com/pay" noMargin />
              <BiLinkExternal className="text-dark ms-2" />
            </Link>
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-7 col-md-7 pe-2">
                <MessageLabel text={"Enable Payment Mode"} />
              </div>
              <div className="col-3 col-md-3 ps-2 text-end">
                <AdminCustomSelect className="payment-mode-custom-select " name="payment_mode" value={formData?.payment_mode} onChange={handleInput} ref={(el) => (combinedRef.current.payment_mode = el)} options={[{ name: "LIVE", value: 1 }]} error={""} defaultOptionName={""} />
              </div>
            </div>
            <MessageLabel text={"Google Pay Label"} className="" />
            <AdminCustomInput type="text" name="google_pay_label" value={formData?.google_pay_label} onChange={handleInput} placeHolder={"Google Pay label"} ref={(el) => (combinedRef.current.google_pay_label = el)} error={formDataError?.google_pay_label} />
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text="Google Pay Product Details" />
            <MessageLabel text={"Unified Product ID"} className="mandatorySimple" />
            <MessageSubHeading text="Enter your Google Pay Product ID for payments." />
            <AdminCustomInput type="text" name="unified_product_id" value={formData?.unified_product_id} onChange={handleInput} placeHolder={"Example: Ax123456789Z"} ref={(el) => (combinedRef.current.unified_product_id = el)} error={formDataError?.unified_product_id} />
          </Wrapper>
          <Wrapper>
            <MessageHeading text="Google Play Config JSON" />
            <MessageSubHeading text="Paste your Google Play configuration JSON here." />
            <textarea
              name="googleplay_config"
              value={formData?.googleplay_config || ""}
              onChange={handleInput}
              placeholder="Paste JSON here..."
              className="form-control"
              style={{ minHeight: "150px", fontSize: "12px", fontFamily: "monospace" }}
              ref={(el) => (combinedRef.current.googleplay_config = el)}
            ></textarea>
          </Wrapper>
          <Wrapper>
            <DeviceSelector
              selectedDevices={formData?.supported_devices || []}
              onDeviceChange={handleDeviceChange}
              gatewayName="googlepay"
              availableDevices={supportedDevices}
              showDescriptions={true}
              label="Supported Devices"
              showSelectAll={true}
              className=""
              cardStyle="default"
              showDeviceStats={true}
            />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={"Update Google Pay"} loading={loading} />
      </FormContainer>
    </>
  );
}

export default GooglePay;
